/**
 * @author NikolaV
 */

const defaults = {
    timeout: 30, // seconds
};


interface ICacheItem {
    key: string;
    group: string;
    data: any;
    timestamp: number;
    timeout: number;
}

let isProbablyFull = false;

clearExpired();

function get(key: string, group: string = ''): null | any {
    return getOrHas('get', key, group);
}

function has(key: string, group: string = ''): boolean {
    return getOrHas('has', key, group);
}

function getOrHas(type: 'get' | 'has', key: string, group: string = '', premadeKey = false): boolean | any {
    if (!isEnabled()) return false;
    if (!key) {
        console.warn(`Cache ${type}: missing key`);
        return false;
    }
    const fullKey = premadeKey ? key : makeKey(key, group);

    const cacheItem: ICacheItem = JSON.parse(localStorage.getItem(fullKey));

    if (cacheItem) {
        const age_ms = Date.now() - cacheItem.timestamp;
        if (age_ms < cacheItem.timeout) {
            //console.log(`Cache ${type} hit:`, fullKey);

            if (type === 'get') {
                return cacheItem.data;
            }
            else if (type === 'has') {
                return true;
            }
        }
        else {
            localStorage.removeItem(fullKey);
        }
    }
    else {
        return false;
    }
}

function set(key: string, data: any, group: string = '', timeout: number = defaults.timeout): boolean {
    if (!isEnabled() || isProbablyFull) return false;
    if (!key || !data) {
        console.warn('Cache set: Missing key or data');
        return false;
    }
    const fullKey = makeKey(key, group);

    const cacheItem = {
        key,
        group,
        data,
        timestamp: Date.now(),
        timeout: timeout * 1000,
    };

    try {
        localStorage.setItem(fullKey, JSON.stringify(cacheItem));
    }
    catch (e) {
        isProbablyFull = true;
        console.warn('Cache set error: localStorage is probably full', e);
    }

    return true;
}

function remove(key: string, group: string = ''): boolean {
    if (!isEnabled()) return false;
    if (typeof key === 'undefined') {
        console.warn('Cache remove: Invalid key');
        return false;
    }

    localStorage.removeItem(makeKey(key, group));
    return true;
}

function clear(group: string = '') {
    if (!isEnabled()) return false;

    forEach(group, k => localStorage.removeItem(k));
    isProbablyFull = false;

    console.log('Cache cleared, group: ' + group);
}

function clearExpired(group: string = '') {
    if (!isEnabled()) return false;
    forEach(group, key => getOrHas('has', key, '', true));
    isProbablyFull = false;
}

function forEach(group: string = '', callback: (key) => void) {
    const hits: string[] = []; //can't remove while iterating

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.indexOf('_cache_' + group) === 0) {
            hits.push(key);
        }
    }

    for (const hit of hits) {
        callback(hit);
    }
}

function makeKey(key: string, group: string = ''): string {
    return '_cache_' + group + '_p' + kuura.getProjectId() + '_u' + kuura.getUserId() + '_' + key;
}

function enable() {
    localStorage.setItem('cache_enabled', 'true');
}

function disable() {
    localStorage.setItem('cache_enabled', 'false');
}

function isEnabled(): boolean {
    let localStorage;
    try {
        localStorage = window.localStorage;
    }
    catch (e) {
    }
    if (!localStorage) return false;
    return localStorage.getItem('cache_enabled') !== 'false';
}

export const Cache = {
    enable,
    disable,
    isEnabled,
    clearExpired,
    clear,
    remove,
    set,
    has,
    get,
    isProbablyFull,
    defaults,
    groups: {
        notificationCounts: 'notification-counts'
    }
};
